// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1DoOg","mediaWrap":"styles_mediaWrap___ckQH","title":"styles_title__sctil","contentWrap":"styles_contentWrap__drzfC","redirectLink":"styles_redirectLink___Fs4q"};
module.exports.__checksum = "4426e34bc27e"